/**
 * 内存字符串/数值统一转为 Gi（整数）。
 *
 * 支持带单位后缀的字符串（如 "4096Mi"、"4Gi"、"1Ti"）以及无单位的数值。
 * 无单位时默认按 Gi 处理（与函数名语义一致）；API 返回的裸数字通常即为 Gi。
 */
export function convertMemoryToGi(value: string | number | undefined | null): number {
  if (!value) return 0;
  const units = ['bit', 'Ki', 'Mi', 'Gi', 'Ti'];
  let unit = '';
  let numericValue = String(value);
  for (const u of units) {
    if (numericValue.endsWith(u)) {
      unit = u;
      numericValue = numericValue.slice(0, -u.length);
      break;
    }
  }
  if (unit === '') {
    // 无单位裸数字默认即 Gi（如 API 返回 memory: 4 表示 4 Gi）
    unit = 'Gi';
  }
  let bitValue = parseFloat(numericValue);
  const unitIndex = units.indexOf(unit);
  if (unitIndex < 3) {
    bitValue = bitValue / 1024 ** (3 - unitIndex);
  } else if (unitIndex > 3) {
    bitValue = bitValue * 1024;
  }
  return Number.isNaN(bitValue) ? 0 : Math.floor(bitValue);
}
